import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LayoutService } from './layout.service';
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  dialogRef!: MatDialogRef<any>;
  constructor(private layoutService: LayoutService) {}
  getDialogConfig() {
    return {
      minWidth: !this.layoutService.isXS() ? 500 : 340,
      maxWidth: 600,
      autoFocus: false,
      disableClose: true,
    };
  }
  closeDialog() {
    this.dialogRef?.close();
  }
}
